import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSafeFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.988 2.187a4.5 4.5 0 0 1 4.024 0l5.59 2.795a.9.9 0 0 1 .498.805v8.028c0 1.716-.813 3.096-2.135 4.375-1.298 1.256-3.178 2.503-5.485 3.96a.9.9 0 0 1-.96 0c-2.342-1.48-4.211-2.874-5.504-4.205-1.275-1.311-2.116-2.69-2.116-4.13V5.787c0-.34.194-.652.498-.805zm5.543 6.671a.75.75 0 0 0-1.06 0l-3.07 3.07-1.27-1.27a.75.75 0 0 0-1.06 1.06l1.8 1.8a.75.75 0 0 0 1.06 0l3.6-3.6a.75.75 0 0 0 0-1.06",
    clipRule: "evenodd"
  }));
}
var IcSafeFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSafeFill));

export { IcSafeFill as I };
